import { render, staticRenderFns } from "./DeleteButton.vue?vue&type=template&id=e141d5ea&scoped=true&"
import script from "./DeleteButton.vue?vue&type=script&lang=ts&"
export * from "./DeleteButton.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteButton.vue?vue&type=style&index=0&id=e141d5ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e141d5ea",
  null
  
)

export default component.exports